import { useConfigureAlertsModal } from "../modals/Alerts";
import type { GetContextMenuSection } from "./helpers";
import { getIcon } from "./icons";
import { useUserSubscriptionTier } from "../../../data/user";

export const useGetMenuItemsAlerts = (): GetContextMenuSection => {
  const { disabledFeatures } = useUserSubscriptionTier();
  const modal = useConfigureAlertsModal();

  return (ctx) => {
    if (!ctx.isProduct || ctx.isHeaderMenu) return [];
    return [
      {
        name: "Alerts",
        disabled: ctx.rangeSelection.some((r) => r.rowId.startsWith("Adhoc")) || disabledFeatures?.priceAlerts,
        tooltip: disabledFeatures?.priceAlerts ? "Please upgrade your subscription to access this feature" : undefined,
        icon: getIcon("alerts", "var(--color-brand)"),
        subMenu: [
          {
            name: "Add new rule",
            disabled: ctx.rangeSelection?.length > 1,
            tooltip: ctx.rangeSelection?.length > 1 ? "Select a single cell to add an alert" : undefined,
            action: () => {
              modal.open({
                active: "add",
                range: ctx.selectedRange,
                width: 700,
                height: 470,
              });
            },
          },
          {
            name: "Manage",
            action: () => {
              modal.open({
                active: "manage",
                range: ctx.selectedRange,
                width: 700,
                height: 470,
              });
            },
          },
        ],
      },
    ];
  };
};
